<div class="search-view">
  <div class="canvas-header">
    <div class="header-left">
      <button mat-icon-button class="toggle-sidebar-btn" (click)="sidenavService.toggle()">
        <mat-icon>{{ sidenavService.isSmallOrTablet() ? 'menu' : 'left_panel_open' }}</mat-icon>
      </button>
      <h2 class="font-600">{{ 'QuestionsSearchView.Title' | translate }}</h2>
    </div>

    <div id="header-toolbar" class="invisible flex-1"></div>

    <div class="actions">
      <button mat-icon-button (click)="closeView()" [matTooltip]="'GenerateContent.Close' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="canvas-content custom-scrollbar">
    <app-search-results
      [editions]="results()?.editions || []"
      [finalAIResponse]="results()?.finalAIResponse || ''"
      [temporaryAnswer]="results()?.temporaryAnswer || ''"
      [searchType]="results()?.searchType || 'text'"
      [loading]="results()?.loading || false"
    ></app-search-results>
  </div>
</div>
